/**
 * Desktop-first responsive breakpoints.
 * CarePro web targets PC browsers; smaller breakpoints cover compact laptops and split-screen layouts.
 */
export const breakpointPx = {
  /** Small laptop / split-screen desktop */
  desktopCompact: 1280,
  /** Narrow desktop / tablet landscape */
  desktopSmall: 1024,
} as const;

export const breakpointMedia = {
  desktopCompactMax: `(max-width: ${breakpointPx.desktopCompact}px)`,
  desktopSmallMax: `(max-width: ${breakpointPx.desktopSmall}px)`,
} as const;

export type BreakpointPx = typeof breakpointPx;
export type BreakpointMedia = typeof breakpointMedia;
